document.addEventListener("DOMContentLoaded", () => {
	const suitableProductCarousels = document.querySelectorAll(".recipe-details__suitable-products-swiper");

	if (suitableProductCarousels.length) {
		suitableProductCarousels.forEach((carousel) => {
			const swiper = new Swiper(carousel, {
				// Optional parameters
				keyboard: true,
				breakpoints: {
					// when window width is >= 425px
					425: {
						slidesPerView: 1,
						spaceBetween: 10,
					},
					// when window width is >= 768px
					768: {
						slidesPerView: 1,
						spaceBetween: 10,
					},
					// when window width is >= 1200px
					1200: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
				},

				// Navigation and Pagination settings
				navigation: {
					nextEl: carousel.parentElement.querySelector(".recipe-details__suitable-products-swiper-navigation .swiper-button-next"),
					prevEl: carousel.parentElement.querySelector(".recipe-details__suitable-products-swiper-navigation .swiper-button-prev"),
				},
				pagination: {
					el: carousel.parentElement.querySelector(".recipe-details__suitable-products-swiper-pagination .swiper-pagination"),
					type: "fraction",
				},
			});
		});
	}
});
